/* eslint-disable no-nested-ternary */
import { useAppSelector } from 'src/store/hooks'
import { LinearProgress } from '@mui/material'

import { selectCurrentQuizQuestion, selectQuiz } from '../live.slice'
import QuizQuestion from './quiz-question'
import QuizFinalResults from './quiz-final-results'

export default () => {
  let quiz = useAppSelector(selectQuiz)
  let currentQuestion = useAppSelector(selectCurrentQuizQuestion)

  return (
    <div>
      <LinearProgress
        variant="determinate"
        value={
          quiz?.questions?.length
            ? (currentQuestion * 100) / (quiz?.questions?.length ?? 0)
            : 0
        }
      />
      {currentQuestion === quiz.questions.length ? (
        <QuizFinalResults />
      ) : (
        quiz?.questions?.map((_, i) => (
          <div style={{ display: i === currentQuestion ? 'block' : 'none' }}>
            <QuizQuestion />
          </div>
        ))
      )}
    </div>
  )
}
